import { h, Component } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import LFeed from "../../../services/live-feed"

export default class SccerStatsTable extends Component {
	render({ event }) {
		if (event.sport != '/sport/1') {
			return null;
		}
		const sport = LFeed.menu['/sport/1']
		return (
			<div class={"live-game-stats-table stats-" + sport.label}>
				<table cellspacing="0" cellpadding="0" class="game-list-statistics back">
					<thead>
						<tr>
							<th>&nbsp;</th>
							<th>
								<span class="ht" title={<Trans>First time score</Trans>}>
									<i>{"HT"}</i>
								</span>
							</th>
							<th>
								<span class="y-card" title={<Trans>Yellow card</Trans>}>
									<i>{"Yellow card"}</i>
								</span>
							</th>
							<th>
								<span class="r-card" title={<Trans>Red card</Trans>}>
									<i>{"Red card"}</i>
								</span>
							</th>
							<th>
								<span class="corner" title={<Trans>Corner</Trans>}>
									<i>{"Corner"}</i>
								</span>
							</th>
							<th>
								<span class="penalty" title={<Trans>Penalty</Trans>}>
									<i>{"Penalty"}</i>
								</span>
							</th>
							{event.misc.stats.offside ? (
								<th>
									<span title={<Trans>Offside</Trans>} class="icon-offside">
										<i>{"Offside"}</i>
									</span>
								</th>
							) : null}
							{event.misc.stats.substitution ? (
								<th>
									<span title={<Trans>Substitution</Trans>} class="icon-substitution">
										<i>{"Substitution"}</i>
									</span>
								</th>
							) : null}
							{event.misc.stats.foul ? (
								<th>
									<span title={<Trans>Foul</Trans>}>{"Foul"}</span>
								</th>
							) : null}
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>
								<p>
									<span />
									<b>{event.teams.home.name || ""}</b>
								</p>
							</td>
							<td>{(event.misc.stats.score_set1 && event.misc.stats.score_set1.team1_value) || 0}</td>
							<td>{(event.misc.stats.yellow_card && event.misc.stats.yellow_card.team1_value) || 0}</td>
							<td>{(event.misc.stats.red_card && event.misc.stats.red_card.team1_value) || 0}</td>
							<td>{(event.misc.stats.corner && event.misc.stats.corner.team1_value) || 0}</td>
							<td>{(event.misc.stats.penalty && event.misc.stats.penalty.team1_value) || 0}</td>
							{event.misc.stats.offside ? <td>{event.misc.stats.offside.team1_value}</td> : null}
							{event.misc.stats.substitution ? <td>{event.misc.stats.substitution.team1_value}</td> : null}
							{event.misc.stats.foul ? <td>{event.misc.stats.foul.team1_value}</td> : null}
						</tr>
						<tr>
							<td>
								<p>
									<span></span>
									<b>{event.teams.away.name || ""}</b>
								</p>
							</td>
							<td>{(event.misc.stats.score_set1 && event.misc.stats.score_set1.team2_value) || 0}</td>
							<td>{(event.misc.stats.yellow_card && event.misc.stats.yellow_card.team2_value) || 0}</td>
							<td>{(event.misc.stats.red_card && event.misc.stats.red_card.team2_value) || 0}</td>
							<td>{(event.misc.stats.corner && event.misc.stats.corner.team2_value) || 0}</td>
							<td>{(event.misc.stats.penalty && event.misc.stats.penalty.team2_value) || 0}</td>
							{event.misc.stats.offside ? <td>{event.misc.stats.offside.team2_value}</td> : null}
							{event.misc.stats.substitution ? <td>{event.misc.stats.substitution.team2_value}</td> : null}
							{event.misc.stats.foul ? <td>{event.misc.stats.foul.team2_value}</td> : null}
						</tr>
					</tbody>
				</table>
			</div>
		);
	}
}
